import React from 'react';

const AllHolders: React.FC = () => <div className="placeholder">AllHolders – coming soon</div>;

export default AllHolders;
